export default "__VITE_ASSET__244bbe29__"